import { State } from '../../types';

export const southDakota: State = {
  name: 'South Dakota',
  abbreviation: 'SD',
  terms: [
    {
      word: 'Belle Fourche',
      phonetic: 'bel-FOOSH',
      // audioUrl: '/audio/belle_fourche.mp3',
      description: 'A city in Butte County, named after the French term for "beautiful fork."'
    },
    {
      word: 'Kadoka',
      phonetic: 'kuh-DOH-kuh',
      // audioUrl: '/audio/kadoka.mp3',
      description: 'A town in Jackson County, with a name meaning "hole in the wall" in Lakota.'
    },
    {
      word: 'Lead',
      phonetic: 'LEED',
      audioUrl: '/audio/lead.mp3',
      description: 'Historic mining city in western South Dakota'
    },
    {
      word: 'Oacoma',
      phonetic: 'oh-uh-KOH-muh',
      // audioUrl: '/audio/oacoma.mp3',
      description: 'A town in Lyman County, often mispronounced due to its unique spelling.'
    },
    {
      word: 'Pierre',
      phonetic: 'PEER',
      // audioUrl: '/audio/pierre.mp3',
      description: 'The capital city of South Dakota, pronounced as "peer" rather than the French "pee-AIR."'
    },
    {
      word: 'Sisseton',
      phonetic: 'SIS-uh-ton',
      // audioUrl: '/audio/sisseton.mp3',
      description: 'A city in Roberts County, named after the Sisseton division of the Sioux tribe.'
    },
    {
      word: 'Wakpala',
      phonetic: 'wahk-PAH-lah',
      // audioUrl: '/audio/wakpala.mp3',
      description: 'A community in Corson County, with a name meaning "creek" in Lakota.'
    },
    {
      word: 'Wasta',
      phonetic: 'WAH-stah',
      // audioUrl: '/audio/wasta.mp3',
      description: 'A town in Pennington County, derived from the Dakota word meaning "good."'
    },
    {
      word: 'Wewela',
      phonetic: 'wee-WEE-lah',
      // audioUrl: '/audio/wewela.mp3',
      description: 'An unincorporated community in Tripp County, with a name meaning "small spring" in Lakota.'
    },
    {
      word: 'Yankton',
      phonetic: 'YANK-tun',
      // audioUrl: '/audio/yankton.mp3',
      description: 'A city in Yankton County, named after the Yankton tribe of the Sioux.'
    }
  ]
};